import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, Input} from '@angular/core';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { QnSbnService } from '../../../../services/qn-sbn-service.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { QnSbnDataService } from '../../../../services/qn-sbn-data-service.service';
import qnsbnurlAPI from  '../../../../services/qn-sbn-API-url';
// TODO Rename and put in its own module
const PPTX_ICON = `
<svg id="Icons_Expanded" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:none;}</style></defs><path class="cls-1" d="M0,24V0H24"/><g id="pptx_V6R" data-name="pptx V6R"><path d="M14,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V8Zm4,18H6V4h7V9h5Z"/><g id="Chart"><path d="M9.5,15.5H12A2.5,2.5,0,1,1,9.5,13Z"/></g><g id="list"><rect x="13" y="15" width="4" height="1"/><rect x="13" y="17" width="4" height="1"/><rect x="13" y="13" width="4" height="1"/></g></g></svg>
`;

const ZIP_ICON = `
<svg id="Icons_Expanded" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:none;}</style></defs><path class="cls-1" d="M0,24V0H24"/><g id="zip_V8" data-name="zip V8"><path d="M14,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V8Zm4,18H6V4h7V9h5Z"/><g id="zipper"><rect x="9.5" y="18" width="2" height="2"/><rect x="7.5" y="16" width="2" height="2"/><rect x="9.5" y="14" width="2" height="2"/><rect x="7.5" y="12" width="2" height="2"/><rect x="9.5" y="10" width="2" height="2"/><rect x="7.5" y="8" width="2" height="2"/><rect x="9.5" y="6" width="2" height="2"/><rect x="7.5" y="4" width="2" height="2"/></g></g></svg>`;

@Component({
  selector: 'dl-file-upload-single',
  templateUrl: './file-upload-single.component.html',
  styleUrls: ['./file-upload-single.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploadSingleComponent implements OnInit {
  // @Input() public fileList_Input;
  public file: File;
  @ViewChild('fileDropRefMul', { static: false }) public fileDropEl: ElementRef;
  public totalAllFileSize = 0;
  public fileSizeobject = { size: 0, type: '' };
  public userFileSize = { size: 0, type: '' };
  public fileTypes = ['image/apng', 'image/bmp', 'image/gif', 'image/jpeg', 'image/pjpeg', 'image/png', 'text/csv', '.csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'application/mspowerpoint', 'application/powerpoint', 'application/vnd.ms-powerpoint', 'application/x-mspowerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/x-7z-compressed', 'application/zip', 'application/x-tar', 'application/vnd.rar', 'application/x-zip-compressed', 'application/x-compressed', 'application/gzip', 'text/plain', 'application/rtf'];
  public notificationId = '';
  public allDraftData = {};
  @Input() ackFileFlag: boolean = true;
  /**
   * Maximum upload total file size limit collectively is 50MB.  Allowed file types are pdf, csv, doc, ppt, excel, jpg, bmp, png, and gif. Maximum allowed attachment files are 10.
   */
  // @Input() public isNewFromTemplate: boolean;
  
  public fileUploadInputDisabled:boolean = false;
  public filesSingle: any[] = [];
  public constructor(private readonly iconRegistry: MatIconRegistry, private readonly sanitizer: DomSanitizer,  private readonly oneSnackBar: OneSnackBarService,private _QnSbnService:QnSbnService,private http: HttpClient,private _QnSbnDataService:QnSbnDataService) {
    this.iconRegistry.addSvgIconLiteral('pptx', this.sanitizer.bypassSecurityTrustHtml(PPTX_ICON));
    this.iconRegistry.addSvgIconLiteral('zip', this.sanitizer.bypassSecurityTrustHtml(ZIP_ICON));    
  }

  public ngOnInit(): void {
    this._QnSbnDataService.mappingData$.subscribe(storeData=>{
      if(Array.isArray(storeData['notificationDocFileList'])){
        this.filesSingle = storeData['notificationDocFileList'];
        this.allDraftData = storeData['notificationRowData'];
        this.notificationId = storeData['localNotificationId']['NotificationId'];
        if(this.filesSingle.length > 0){
          this.fileUploadInputDisabled = true;
        }
      }            
    })
  }
  /**
   * on file drop handler
   */
  public onFileDroppedandSelect($event: any): void {
    this.addfile($event);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  public deleteFile(index: number): void {  
    // console.log('index is ---',index);
    this.filesSingle.splice(index,1);
    // this.maxFileAllowed = this.maxFileAllowed-1;
    // this.totalAllFileSize = this.totalAllFileSize - fileTobedelete.size;
    // this.bytesCalculation(this.totalAllFileSize);
    // this.fileSizeobject.size = this.userFileSize.size;
    // this.fileSizeobject.type = this.userFileSize.type;
    this.fileUploadInputDisabled = false;
    this.addProduct();
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  public prepareFilesList(files: any): void {
    const filetype: string = files.type;
    files.uploadFile = true;
    switch (filetype) {
      case 'image/apng':
      case 'image/bmp':
      case 'image/gif':
      case 'image/pjpeg':
      case 'image/png':
      case 'image/jpeg':
        files.fileIcon = 'image';
        break;
      case 'text/csv':
      case '.csv':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      case 'application/vnd.ms-excel':
        files.fileIcon = 'file_excel';
        break;
      case 'application/msword':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        files.fileIcon = 'file_word';
        break;
      case 'application/pdf':
        files.fileIcon = 'file_pdf';
        break;
      case 'application/mspowerpoint':
      case 'application/powerpoint':
      case 'application/vnd.ms-powerpoint':
      case 'application/x-mspowerpoint':
      case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        files.fileIcon = 'pptx_Icon';
        break;
      case 'application/x-7z-compressed':
      case 'application/zip':
      case 'application/x-tar':
      case 'application/vnd.rar':
      case 'application/x-zip-compressed':
      case 'application/x-compressed':
      case 'application/gzip':
        files.fileIcon = 'zip_Icon';
        break;
      default:
        files.fileIcon = 'document'; // icon is not available , temp document used
        break;
    }
    if(!(/[!@#$%^&*,?"{}|<>]/).test(files.name)){
      if(files.size > 0 && files.size <= 15000000){
        this.filesSingle = [];
        this.fileUploadInputDisabled = true;      
        this.filesSingle.push(files); 
        this.addProduct();
        // console.log('files:--',this.filesSingle)       
      }else if(files.size <=0 || files.size > 15000000){
        // this.totalAllFileSize = 0;
        // this.bytesCalculation(this.totalAllFileSize);
        // this.fileSizeobject.size = 0;
        // this.fileSizeobject.type = "";
        this.filesSingle.length = 0;
        this.oneSnackBar.open('File size is either 0 MB or greater than 15 MB to upload.', OneSnackBarType.ERROR);
        return;
      }
    }else{
      this.oneSnackBar.open('File name should not have special characters !@#$%^&*,?"{}|<>', OneSnackBarType.ERROR);
      return;
    }
    
    // this.dataToBeSaveOnS3(files.name);
    // this.maxFileAllowed = this.maxFileAllowed+1;
    this.oneSnackBar.open('Attachment successfully added', OneSnackBarType.SUCCESS);
  }

  public bytesCalculation(bytes: number, decimals: number = 2): any {
    if (bytes === 0) {
      this.userFileSize.size = 0;
      this.userFileSize.type = '';
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    this.userFileSize.size = 0;
    this.userFileSize.type = '';

    this.userFileSize.size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    this.userFileSize.type = sizes[i];
    return this.userFileSize;
  }
  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  public formatBytes(bytes: number, decimals: number = 2): string {
    this.bytesCalculation(bytes, decimals);
    return this.userFileSize.size + ' ' + this.userFileSize.type;
  }

  public validFileType(file: File): boolean {
    return this.fileTypes.includes(file.type);
  }

  public addfile(event: any): void {
    for (const item of event) {
      if (this.validFileType(item)) {
        this.prepareFilesList(item);
      } else {
        this.oneSnackBar.open(item.name + ' is not supported file type.', OneSnackBarType.ERROR);
      }
    }
    this.fileDropEl.nativeElement.value = '';
  }

  public addProduct() { 
    this._QnSbnDataService.getMappedQnsbnData(this.filesSingle,"NotificationDocFileList");
  }

  public downloadAttachment(fileName: string) {
    const isSavedFile = this.verifyAttachment(fileName);
    if(isSavedFile) {
      this._QnSbnService.downloadLocalAttachmentApi(fileName, this.notificationId);
    } else {
      return;
    }
  }

  public verifyAttachment(fileName: string): boolean {
    const uploadedFiles = this.allDraftData['NotificationAttachments'] || [];
    const isSavedFile = uploadedFiles.some(fileItem => fileItem.FileName === fileName && fileItem.NotificationDoc);
    return isSavedFile;
  }

}
